import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconCode: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.69224 11.964L5.15628 12.4281L6.08435 11.5L5.62031 11.036L2.58435 7.99999L5.62031 4.96403L6.08435 4.49999L5.15628 3.57191L4.69224 4.03595L1.34692 7.38128C1.00521 7.72298 1.00521 8.27701 1.34692 8.61871L4.69224 11.964ZM11.3079 11.964L10.8438 12.4281L9.91573 11.5L10.3797 11.036L13.4157 7.99999L10.3797 4.96403L9.91573 4.49999L10.8438 3.57191L11.3079 4.03595L14.6532 7.38128C14.9948 7.72298 14.9948 8.27701 14.6532 8.61871L11.3079 11.964Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.21969 14.5303L6.75002 15.0607L7.81068 14L7.28035 13.4697L3.81068 9.99999L7.28035 6.53032L7.81068 5.99999L6.75002 4.93933L6.21969 5.46966L2.39647 9.29289C2.00595 9.68341 2.00595 10.3166 2.39647 10.7071L6.21969 14.5303ZM13.7804 14.5303L13.25 15.0607L12.1894 14L12.7197 13.4697L16.1894 9.99999L12.7197 6.53032L12.1894 5.99999L13.25 4.93933L13.7804 5.46966L17.6036 9.29289C17.9941 9.68341 17.9941 10.3166 17.6036 10.7071L13.7804 14.5303Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.74714 17.0966L8.34376 17.6933L9.53701 16.5L8.94039 15.9034L5.03701 12L8.94039 8.09661L9.53701 7.49999L8.34376 6.30675L7.74714 6.90337L3.44602 11.2045C3.00668 11.6438 3.00668 12.3562 3.44602 12.7955L7.74714 17.0966ZM16.2529 17.0966L15.6562 17.6933L14.4631 16.5L15.0597 15.9034L18.9631 12L15.0597 8.09661L14.4631 7.49999L15.6562 6.30675L16.2529 6.90337L20.554 11.2045C20.9934 11.6438 20.9934 12.3562 20.554 12.7955L16.2529 17.0966Z"
                        fill="currentColor"
                    />
                </svg>
            );
    }
};
